import '~components/LeftSideMenu/LeftSideMenu.scss';

const LeftSideMenu = () => {
  return <div className={'CAKE__left-side-menu'}></div>;
};

export default LeftSideMenu;
